<template>
  <div class="services__btn-modal--wrapper">
    <button v-if="services.length > 1" class="services__btn-modal" :id="idBtn" type="button" @click="openModalServices(services)">
      {{ multipleOfferLabel }}
    </button>
    <div v-else class="services__btn-modal--wrapper-single-offer">
      <p>{{ singleOfferLabel }} :</p>
      <a :href="services[0].os_lien">{{ services[0].tm_X3b_und_title[0] }}</a>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
  idBtn: {
    default: () => null,
    required: false,
    type: String,
  },
  openModalServices: {
    required: true,
    type: Function,
  },
  services: {
    required: true,
    type: Object,
  },
});

const multipleOfferLabel = window.drupalSettings.services_popin.services_cta_label_multi;
const singleOfferLabel = window.drupalSettings.services_popin.services_cta_label_single;
</script>
